import { CommonModule } from '@angular/common';
import {
  Component,
  ComponentRef,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import {
  DxPopupComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcPopupSettings } from './abc-popup-settings';

@Component({
  selector: 'abc-popup',
  template: `
    <div *ngIf="!component; else contentComponent"></div>
    <ng-content></ng-content>
    <ng-template #contentComponent></ng-template>
  `,
  styleUrls: ['./abc-popup.component.scss'],
  imports: [CommonModule],
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class AbcPopupComponent extends DxPopupComponent implements OnDestroy {
  @ViewChild('contentComponent', { static: true, read: ViewContainerRef }) contentComponent: ViewContainerRef;
  @Input() component: any;
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.wrapperAttr = {
      class: 'abc-popup-default-class',
    };
  }

  ngOnDestroy(): void {
    this.contentComponent.clear();
  }

  public openPopUp(): ComponentRef<unknown> {
    this.visible = true;
    const componentRef = this.contentComponent.createComponent(this.component);
    return componentRef;
  }

  public applyPopupSettings(popupSettings?: AbcPopupSettings): void {
    if (popupSettings) {
      this.title = popupSettings.title;

      this.height = popupSettings.height;
      this.width = popupSettings.width;

      if (popupSettings.maxHeight) {
        this.maxHeight = popupSettings.maxHeight;
      }

      if (popupSettings.maxWidth) {
        this.maxWidth = popupSettings.maxWidth;
      }

      this.resizeEnabled = popupSettings.resizeEnabled;
      this.shading = popupSettings.shading;
    }
  }
}
